// extracted by mini-css-extract-plugin
module.exports = {"root":"Ambassadors_root__3Vbmp","title":"Ambassadors_title__29XTn","description":"Ambassadors_description__1lr0p","bannerWrapper":"Ambassadors_bannerWrapper__3EGGs"};